// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#footer-sect {
	background: linear-gradient(to bottom, 
		var(--scouting-america-dark-blue) 0%, 
		var(--scouting-america-black) 100%);
	color: var(--scouting-america-white);
	width: 100%;
	min-height: 50px;
	
	padding-left: 30px;
	padding-right: 30px;
	padding-top: 10px;
	padding-bottom: 10px;

	font-family: var(--font-1);
	border-top: 4px solid var(--scouting-america-red);
	box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.2);
}

#footer-topsect {
	color: var(--scouting-america-pale-blue);

	padding-bottom: 15px;

	margin: 0 0 20px 0;

	font-size: var(--body-normal-size);
	text-align: center;

	border-bottom: 1px solid var(--scouting-america-pale-blue);
}

#footer-bodysect {
	max-width: 1400px;
	width: 100%;

	margin: 30px auto;
}

.footer-sidesect {
	flex: 1 1;
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.footer-textrow {
	margin: 0 0 12px 0;

	font-size: var(--body-normal-size);
	line-height: 1.7;
}

#footer-sect a {
	color: var(--scouting-america-white);

	padding-bottom: 2px;

	font-weight: 700;
	text-decoration: underline;

	transition: all 0.2s ease;
}
	#footer-sect a:hover {
		color: var(--scouting-america-red);
	}
	#footer-sect a:visited {
		color: var(--scouting-america-pale-blue);
	}
	#footer-sect a:visited:hover {
		color: var(--scouting-america-red);
	}

#footer-sect em {
	color: var(--scouting-america-white);

	font-weight: bold;
	font-style: normal;
	text-decoration: none;
}

#footer-bottomsect {
	margin: 30px 0 0 0;
	text-align: center;
	padding-top: 20px;
	border-top: 1px solid var(--scouting-america-pale-blue);
	font-size: var(--body-normal-size);
}

.footer-textrow {
	margin-top: 0px;
	margin-bottom: 8px;

	font-size: var(--body-small-size);
}


@media (min-width: 451px) {
	#footer-bodysect {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;

		gap: 40px;
	}
}

@media (max-width: 450px) {
	#footer-bodysect {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	#footer-leftsect {
		margin-bottom: 10px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/FooterBar/FooterBar.css"],"names":[],"mappings":"AAAA;CACC;;qCAEoC;CACpC,oCAAoC;CACpC,WAAW;CACX,gBAAgB;;CAEhB,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,oBAAoB;;CAEpB,0BAA0B;CAC1B,iDAAiD;CACjD,0CAA0C;AAC3C;;AAEA;CACC,wCAAwC;;CAExC,oBAAoB;;CAEpB,kBAAkB;;CAElB,kCAAkC;CAClC,kBAAkB;;CAElB,0DAA0D;AAC3D;;AAEA;CACC,iBAAiB;CACjB,WAAW;;CAEX,iBAAiB;AAClB;;AAEA;CACC,SAAO;CACP,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,kBAAkB;;CAElB,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA;CACC,oCAAoC;;CAEpC,mBAAmB;;CAEnB,gBAAgB;CAChB,0BAA0B;;CAE1B,yBAAyB;AAC1B;CACC;EACC,kCAAkC;CACnC;CACA;EACC,wCAAwC;CACzC;CACA;EACC,kCAAkC;CACnC;;AAED;CACC,oCAAoC;;CAEpC,iBAAiB;CACjB,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,uDAAuD;CACvD,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,kBAAkB;;CAElB,iCAAiC;AAClC;;;AAGA;CACC;EACC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;;EAEvB,SAAS;CACV;AACD;;AAEA;CACC;EACC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;AACD","sourcesContent":["#footer-sect {\n\tbackground: linear-gradient(to bottom, \n\t\tvar(--scouting-america-dark-blue) 0%, \n\t\tvar(--scouting-america-black) 100%);\n\tcolor: var(--scouting-america-white);\n\twidth: 100%;\n\tmin-height: 50px;\n\t\n\tpadding-left: 30px;\n\tpadding-right: 30px;\n\tpadding-top: 10px;\n\tpadding-bottom: 10px;\n\n\tfont-family: var(--font-1);\n\tborder-top: 4px solid var(--scouting-america-red);\n\tbox-shadow: 0 -4px 12px rgba(0, 0, 0, 0.2);\n}\n\n#footer-topsect {\n\tcolor: var(--scouting-america-pale-blue);\n\n\tpadding-bottom: 15px;\n\n\tmargin: 0 0 20px 0;\n\n\tfont-size: var(--body-normal-size);\n\ttext-align: center;\n\n\tborder-bottom: 1px solid var(--scouting-america-pale-blue);\n}\n\n#footer-bodysect {\n\tmax-width: 1400px;\n\twidth: 100%;\n\n\tmargin: 30px auto;\n}\n\n.footer-sidesect {\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n}\n\n.footer-textrow {\n\tmargin: 0 0 12px 0;\n\n\tfont-size: var(--body-normal-size);\n\tline-height: 1.7;\n}\n\n#footer-sect a {\n\tcolor: var(--scouting-america-white);\n\n\tpadding-bottom: 2px;\n\n\tfont-weight: 700;\n\ttext-decoration: underline;\n\n\ttransition: all 0.2s ease;\n}\n\t#footer-sect a:hover {\n\t\tcolor: var(--scouting-america-red);\n\t}\n\t#footer-sect a:visited {\n\t\tcolor: var(--scouting-america-pale-blue);\n\t}\n\t#footer-sect a:visited:hover {\n\t\tcolor: var(--scouting-america-red);\n\t}\n\n#footer-sect em {\n\tcolor: var(--scouting-america-white);\n\n\tfont-weight: bold;\n\tfont-style: normal;\n\ttext-decoration: none;\n}\n\n#footer-bottomsect {\n\tmargin: 30px 0 0 0;\n\ttext-align: center;\n\tpadding-top: 20px;\n\tborder-top: 1px solid var(--scouting-america-pale-blue);\n\tfont-size: var(--body-normal-size);\n}\n\n.footer-textrow {\n\tmargin-top: 0px;\n\tmargin-bottom: 8px;\n\n\tfont-size: var(--body-small-size);\n}\n\n\n@media (min-width: 451px) {\n\t#footer-bodysect {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tjustify-content: space-between;\n\t\talign-items: flex-start;\n\n\t\tgap: 40px;\n\t}\n}\n\n@media (max-width: 450px) {\n\t#footer-bodysect {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\n\t#footer-leftsect {\n\t\tmargin-bottom: 10px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
